import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const Route4 = ({
  width = 576,
  height = 207,
  stroke = colors.light,
  opacity = 1,
  offset = 0,
  pathLength = 1204,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 207"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        strokeWidth="3"
        stroke={stroke}
        opacity={opacity}
        ref={forwardRef}
        strokeDashoffset={offset * pathLength}
        strokeDasharray={pathLength}
        d="M447,145C430,152.5 429.9,170.5 405.5,172.5C375,175 363,202 363.5,176C364,150 379.5,105 409,101.5C438.5,97.9995 451,79.4995 461,70.9995C471,62.4995 470,53.9995 480.5,54.4995C491,54.9995 489,68.4995 503.5,68.4995C518,68.4995 521,55.4995 531.5,50.9995C542,46.4995 561,43.4995 571,43.4995C581,43.4995 569,45.9995 546.5,49.4995C524,52.9995 541,70.9995 491,70.9995C441,70.9995 439,39.9995 455,24.9995C471,9.99953 449,-4.00049 439,4.99951C429,13.9995 369,13.9995 347,4.99951C325,-4.00049 291,1.99951 289,24.9995C287,47.9995 257,64.9995 224,64.9995C191,64.9995 180,56.9995 161,39.9995C145.8,26.3995 146,36.6662 148,49.9995C150,63.3328 153.8,85.3995 153,106.999C152.2,128.599 140.5,125.5 118,130.999C95,133.333 47,143.599 39,165.999C31,188.399 10.3333,201.999 1,205.999"
      />
    </svg>
  )
}

export default Route4
